import { getIcfDocumentSetHandler } from '../getIcfDocumentSet/mock'
import { getIcfDocumentSetsHandler } from '../getIcfDocumentSets/mock'

export const icfDocumentHandlers = [
  getIcfDocumentSetsHandler(),
  getIcfDocumentSetHandler(),
]
